import React from 'react';
import {Result,Button} from 'antd';
import { useTranslation } from 'react-i18next';

function ForbiddenPage(props){
	const {t} = useTranslation();
	return (
		<>
			<Result
				status="403"
				title="403"
				subTitle={t("Sorry, you are not authorized to access this page.")}
				extra={
					<Button type="primary">
						<a href="/ade-platform/web/public">{t("Back Home")}</a>
					</Button>
				}
  		/>
		</>
	);
}

export default ForbiddenPage;
